module.exports = __webpack_public_path__ + "img/20.e8f97108.jpg";